<template>
    <!-- <q-layout view="hHh lpR fFf"> -->
    <!-- <customHeader title="알림" path="inform" /> -->

    <!-- <q-page-container> -->
    <q-page style="background-color: #fafafa">
        <div class="flex align-center + justify-between" style="padding: 5.33vmin 14vmin 4.67vmin; border-bottom: 1px solid #e0e0e0; background-color: white">
            <div>
                <span v-if="type === 100" class="informTt40 cccBlue">[{{ typeStr }}]</span>
                <span v-if="type === 200" class="informTt40 cccGrey">[{{ typeStr }}]</span>
                <span v-if="type === 300" class="informTt40 cccGrey">[{{ typeStr }}]</span>
                <span v-if="type === 400" class="informTt40 cccRed">[{{ typeStr }}]</span>
                <span class="informTt40">{{ props.study?.title }}</span>
                <!-- <span class="text-h5 text-bold">{{ study?.title }}</span> -->
            </div>
            <div>
                <span class="dateTt30">{{ props.study?.createdTs }}</span>
            </div>
        </div>
        <div style="margin: 4.17vmin 14vmin">
            <div class="boxRounded">
                <p v-html="props.study?.contents" style="font-size: 1.4vw"></p>
            </div>
        </div>
        <!--  <div style="text-align: center">
                    <q-btn :onClick="onBack" color="primary" label="목록으로" style="margin: 60px 0; width: 15%; font-size: 1.6rem; border-radius: 1vmin" />

                    // <q-btn class="btnBig text-h6" @click="onBack" label="목록으로" color="primary"> </q-btn>
                </div> -->
        <div class="btn__box" style="padding-bottom: 100px">
            <CusButton :type="550" :label="`목록으로`" @onReturn="onBack" />
            <!-- <q-btn :onClick="onBack" class="btn" color="primary" label="목록으로" /> -->
        </div>
    </q-page>
    <!-- </q-page-container> -->
    <!-- </q-layout> -->
</template>

<!-- {
    "seq": 13,
    "title": "알림제목12",
    "contents": "알림내용12",
    "creatorName": "관리자",
    "createdTs": "2023.02.23"
  }, -->
<script setup>
import { onUnmounted, onMounted, ref, watch, computed, defineProps, defineEmits } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';
import { getNotice } from '@/api/modules/mypage.js';
import CusButton from '@/components/widget/CusButton.vue';

import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import Comm from '@/components/common.js';
const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

// const study = ref();
// const type = ref();
// const typeStr = ref();
const type = computed(() => {
    const type = props.study.typeStr;
    return Comm.getNoOfInformStudyType(type);
});
const typeStr = computed(() => {
    const type = props.study.typeStr;
    return Comm.getStrOfInformStudyType(type);
});

const props = defineProps({
    study: {
        type: Object,
        default: null,
        required: true,
    },
    isStudyDetail: {
        type: Boolean,
        default: true,
    },
});
const emit = defineEmits(['update:isStudyDetail']);

onMounted(async () => {});
////////////////////////////----OnClick----////////////////////////////
const onBack = () => {
    // router.push('/inform');
    emit('update:isStudyDetail', false);
};
// const onHome = () => {
//     router.push('/learninghome');
// };
</script>

<style lang="scss">
.boxRounded {
    margin: 0;
    padding: 5.33vmin;
}

.btn {
    width: 25%;
    max-width: 435px;
    margin: 5vmin 0;
    padding: 2.33vmin;
    border-radius: 1vmin;

    &__box {
        text-align: center;
    }

    .q-btn__content {
        .block {
            font-size: 1.2vw;
            line-height: 1.6vw;
            font-weight: 700;
        }
    }
}
.q-btn--actionable.q-btn--standard:before {
    box-shadow: inherit;
}
</style>
